import { showToast } from 'vant'
import vw from '@/utils/inline-px-to-vw'

// 动态导入图片
let successIconBase64 = null

// 异步加载图片并转换为base64
const loadSuccessIcon = async () => {
  try {
    const iconModule = await import('@/assets/theme/userInfo/gou.png')
    const response = await fetch(iconModule.default)
    const blob = await response.blob()
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.warn('加载图标失败，使用Vant内置图标替代', error)
    return null
  }
}
// 预加载图标
loadSuccessIcon().then((base64) => {
  successIconBase64 = base64
})

/**
 * 成功提示
 */
export const successToast = (message, duration = 1000) => {
  return new Promise((resolve) => {
    // 决定加载图标的 Promise
    const iconLoadPromise = successIconBase64
      ? Promise.resolve(successIconBase64) // 如果已有，直接返回
      : loadSuccessIcon()
          .then((base64) => base64 || '')
          .catch(() => '') // 加载失败返回空

    iconLoadPromise.then((iconSrc) => {
      const toast = showToast({
        type: 'html',
        message: `<div style="display: flex;align-items: center;padding: 0;max-width: ${vw(300)};"><div style="display: flex;align-items: center;justify-content: center;
              background-color: #07c160;
              border-radius: 50%;
              width: ${vw(20)};
              height: ${vw(20)};
              margin-right: ${vw(12)};
              flex-shrink: 0;
            ">${iconSrc ? `<img src="${iconSrc}" style="width: ${vw(12)}; height: ${vw(12)};" />` : ``}</div><div style="
              flex: 1;
              color: white;
              font-size: ${vw(14)};
              word-break: break-word;
              white-space: pre-line;
              text-align: left;
            ">${message.replace(/\n/g, '<br>')}</div></div>`,
        duration,
      })

      console.log('toast ----- ', toast)

      if (toast && toast.then) {
        toast.then(() => resolve())
      } else {
        // 如果 showToast 没有返回 Promise，设定延时后 resolve
        setTimeout(resolve, duration)
      }
    })
  })
}

/**
 * 失败提示
 */
export const errorToast = (message, duration = 1000) => {
  return new Promise((resolve) => {
    const toast = showToast({
      type: 'html',
      message: `<div style="display: flex;align-items: center;max-width: ${vw(300)};">
            <div style="display: flex;align-items: center;justify-content: center;
              background-color: #ea4e3d;
              border-radius: 50%;
              width: ${vw(20)};
              height: ${vw(20)};
              margin-right: ${vw(12)};
              flex-shrink: 0;
            "><span style="font-size: ${vw(12)};">✖</span>
            </div>
            <div style="
              flex: 1;
              color: white;
              font-size: ${vw(14)};
              word-wrap: break-word;
              overflow-wrap: break-word;
              text-align: left;
            ">${message.replace(/\n/g, '<br>')}</div></div>`,
      duration,
    })

    if (toast && toast.then) {
      toast.then(() => resolve())
    } else {
      // 如果 showToast 没有返回 Promise，设定延时后 resolve
      setTimeout(resolve, duration)
    }
  })
}
